import { jsx, Fragment } from "react/jsx-runtime";
import { ColumnOverlayWrapper, CellOverlayWrapper } from "./ColumnOverlayStyles.js";
import { useColumnSelectionGroupContext } from "../../../context/useColumnSelectionGroupContext.js";
import { useColumnSelectionContext } from "../../../context/useColumnSelectionContext.js";
const ColumnOverlay = ({
  isFirstColumn,
  column
}) => {
  const { indexedOverlays, queuedOverlays } = useColumnSelectionGroupContext();
  const { selectedColumnsState } = useColumnSelectionContext();
  const configKey = column.value ?? "";
  const overlayData = queuedOverlays[configKey] ?? indexedOverlays[configKey];
  const leftBorderOffset = isFirstColumn ? 1 : 0;
  return /* @__PURE__ */ jsx(Fragment, { children: overlayData && /* @__PURE__ */ jsx(
    ColumnOverlayWrapper,
    {
      leftOffset: leftBorderOffset,
      width: overlayData.width,
      state: selectedColumnsState,
      children: /* @__PURE__ */ jsx(CellOverlayWrapper, {})
    },
    configKey
  ) });
};
export {
  ColumnOverlay
};
